import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IContactCategoryResponse } from "@miplatform/types";

export const useContactCategories = () => {
  const [contactCategories, setContactCategories] = useState<
    IContactCategoryResponse[]
  >([]);

  const stateManager = useComponentState();

  const getContactCategories = (type: string) => {
    return stateManager.run(async () => {
      const response = await accountService.contactCategories.getByType({
        type,
        sort: "label",
        filters: { isActive: true },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setContactCategories(response.data);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    getContactCategories,
    contactCategories,
  };
};
